module.exports = __webpack_public_path__ + "static/media/tiktok-side-icons.d83101dd.svg";